import axios from 'axios';

const baseURL = 'https://utils.diveintohacking.com/api/v1/articles';

export default axios.create({
  baseURL,
  headers: { 'X-Hamshiki-Token': 'token123' },
});
